"use client";

import { usePathname } from "next/navigation";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isMeetingPage = pathname?.startsWith("/meeting");

  // Don't show header/footer on meeting pages (full-screen video call)
  if (isMeetingPage) {
    return <main className="h-screen w-screen overflow-hidden">{children}</main>;
  }

  return (
    <div>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
